import { render, staticRenderFns } from "./agent.vue?vue&type=template&id=8bd4f1ce&scoped=true&"
import script from "./agent.vue?vue&type=script&lang=js&"
export * from "./agent.vue?vue&type=script&lang=js&"
import style0 from "./agent.vue?vue&type=style&index=0&id=8bd4f1ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd4f1ce",
  null
  
)

export default component.exports